export default "__VITE_ASSET__d71323a6__"